import React, { useState, useEffect } from 'react';
import { Menu, X, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMenuOpen(false);
        }
    };



    return (
        <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
            }`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <div className="flex items-center space-x-2">
                        <img className="h-12 w-12" src='/logo.png' />
                        <span className="text-xl font-bold text-blue-700">Sai Samriddhi Micro Finance Association</span>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-8">
                        <button onClick={() => { navigate('/'); scrollToSection('home') }} className="text-gray-700 hover:text-blue-700 transition-colors duration-200 font-medium">
                            Home
                        </button>
                        <button onClick={() => { navigate('/'); scrollToSection('about') }} className="text-gray-700 hover:text-blue-700 transition-colors duration-200 font-medium">
                            About
                        </button>
                        <button onClick={() => { navigate('/'); scrollToSection('services') }} className="text-gray-700 hover:text-blue-700 transition-colors duration-200 font-medium">
                            Services
                        </button>
                        <button onClick={() => { navigate('/'); scrollToSection('gallery') }} className="text-gray-700 hover:text-blue-700 transition-colors duration-200 font-medium">
                            Gallery
                        </button>
                        <button onClick={() => { navigate('/'); scrollToSection('contact') }} className="text-gray-700 hover:text-blue-700 transition-colors duration-200 font-medium">
                            Contact
                        </button>
                    </nav>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-700 hover:text-blue-700 focus:outline-none"
                        >
                            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <div className="md:hidden bg-white border-t border-gray-200">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            <button onClick={() => scrollToSection('home')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-700 hover:bg-gray-50 rounded-md transition-colors duration-200">
                                Home
                            </button>
                            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-700 hover:bg-gray-50 rounded-md transition-colors duration-200">
                                About
                            </button>
                            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-700 hover:bg-gray-50 rounded-md transition-colors duration-200">
                                Services
                            </button>
                            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-700 hover:bg-gray-50 rounded-md transition-colors duration-200">
                                Gallery
                            </button>
                            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-700 hover:bg-gray-50 rounded-md transition-colors duration-200">
                                Contact
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;